import { render, staticRenderFns } from "./Alpha.vue?vue&type=template&id=aab20272&scoped=true"
import script from "./Alpha.vue?vue&type=script&lang=js"
export * from "./Alpha.vue?vue&type=script&lang=js"
import style0 from "../../../../company/statistics/css/fullCompanyDetail.css?vue&type=style&index=0&id=aab20272&prod&scoped=true&lang=css&external"
import style1 from "../../../../company/statistics/css/commonCompany.css?vue&type=style&index=1&id=aab20272&prod&scoped=true&lang=css&external"
import style2 from "./Alpha.vue?vue&type=style&index=2&id=aab20272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab20272",
  null
  
)

export default component.exports